// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../../atom/Atom_Cell.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Atom_Divider from "../../atom/Atom_Divider.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Atom_Checkbox from "../../atom/Atom_Checkbox.bs.js";
import * as Atom_Textfield from "../../atom/Atom_Textfield.bs.js";
import * as Atom_Icon_Internal from "../../atom/icon/Atom_Icon_Internal.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Organism_Newsletter_Ds from "./Organism_Newsletter_Ds.bs.js";
import * as Particle_Accessibility from "../../particle/Particle_Accessibility.bs.js";
import * as UseSubscribeToNewsletter from "../../../hook/UseSubscribeToNewsletter.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";

function textId(style) {
  if (style) {
    return "newsletter-feedback-zone";
  } else {
    return "newsletter-feedback-footer";
  }
}

function Organism_Newsletter$Feedback(Props) {
  var feedback = Props.feedback;
  var style = Props.style;
  var match = UseSubscribeToNewsletter.UseSubscribeToNewsletter_Ds.make(feedback);
  var icon = match.icon;
  var match$1 = Organism_Newsletter_Ds.make(style);
  var blockSpace = typeof feedback === "number" ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined)) : match$1.feedbackBlockSpace;
  return React.createElement(Atom_Row.make, {
              accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Assertive", undefined, undefined, undefined, undefined, undefined),
              blockSpace: blockSpace,
              children: null,
              displayOrder: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2),
              innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS"),
              rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.flexWrap(CssJs.nowrap)]),
              width: Particle_Screen_Constants.oneHundredPctWidth
            }, React.createElement(Atom_Cell.make, {
                  justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
                  width: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.px(15)),
                  children: icon !== undefined ? React.createElement(Atom_Icon_Internal.make, {
                          icon: icon
                        }) : null,
                  rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.alignSelf("center")])
                }), React.createElement(Atom_Text.make, {
                  children: match.textFeedback,
                  id: style ? "newsletter-feedback-zone" : "newsletter-feedback-footer",
                  kind: "span",
                  style: match.textStyleFeedback
                }));
}

var Feedback = {
  make: Organism_Newsletter$Feedback
};

function Organism_Newsletter(Props) {
  var labels = Props.labels;
  var feedback = Props.feedback;
  var style = Props.style;
  var sourceOpt = Props.source;
  var source = sourceOpt !== undefined ? sourceOpt : "replay_footer";
  var input = React.useRef(null);
  var match = UseSubscribeToNewsletter.make(feedback, source, input);
  var match$1 = Organism_Newsletter_Ds.make(style);
  var rules = style ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []) : Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.maxWidth(CssJs.px(300))], undefined, []);
  var divider = style ? null : React.createElement(Atom_Divider.make, {
          style: Atom_Divider.footer,
          display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "block")
        });
  var id = "newsletterZoneCheckbox-" + source;
  var checkboxLabel = React.createElement(React.Fragment, undefined, labels.termOfUse.text + " ", React.createElement(Atom_Cta.Link.make, {
            href: labels.termOfUse.link,
            label: labels.termOfUse.textLink,
            style: match$1.checkboxCtaStyle,
            target: "Blank"
          }));
  return React.createElement(React.Fragment, undefined, divider, React.createElement(Atom_Column.make, {
                  area: "newsletter",
                  blockSpace: match$1.blockSpace,
                  children: null,
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S"),
                  rules: rules,
                  width: match$1.width
                }, React.createElement(Atom_Text.make, {
                      children: labels.title,
                      kind: match$1.titleKind,
                      maxWidth: match$1.titleMaxWidth,
                      style: match$1.titleStyle
                    }), React.createElement(Atom_Column.make, {
                      children: React.createElement(Atom_Row.make, {
                            children: null,
                            innerSpace: match$1.textfieldInnerSpace
                          }, React.createElement(Atom_Column.make, {
                                autoSize: match$1.textfieldAutoSize,
                                blockSpace: match$1.textfieldBlockSpace,
                                children: React.createElement(Atom_Textfield.make, {
                                      ariaDescribedby: style ? "newsletter-feedback-zone" : "newsletter-feedback-footer",
                                      title: labels.inputTitle,
                                      type_: "email",
                                      placeholder: labels.email,
                                      onChange: match.onChange,
                                      required: true,
                                      rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.height({
                                                  NAME: "percent",
                                                  VAL: 100
                                                })]),
                                      style: match$1.textfieldStyle,
                                      focusOutline: {
                                        TAG: /* Textfield */7,
                                        _0: /* Active */0
                                      },
                                      autoComplete: "email",
                                      pattern: /* Email */0,
                                      name: "newsletterEmail",
                                      inputRef: input
                                    }),
                                displayOrder: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 0)
                              }), React.createElement(Organism_Newsletter$Feedback, {
                                feedback: match.state.feedback,
                                style: style
                              }), React.createElement(Atom_Cell.make, {
                                displayOrder: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 3),
                                blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("XS")),
                                width: Particle_Screen_Constants.oneHundredPctWidth,
                                children: React.createElement(Atom_Checkbox.make, {
                                      required: true,
                                      label: checkboxLabel,
                                      onChange: match.onCheckboxClick,
                                      textStyle: Atom_Text_Ds.makeTos("Desc"),
                                      id: id,
                                      displayOrder: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 3),
                                      style: match$1.checkboxStyle
                                    })
                              }), React.createElement(Atom_Column.make, {
                                children: React.createElement(Atom_Cta.Button.make, {
                                      accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, labels.buttonAriaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                      label: labels.button,
                                      style: match$1.buttonStyle,
                                      type_: "submit"
                                    }),
                                displayOrder: match$1.displayButtonOrder,
                                rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.alignSelf("flexStart")]),
                                width: match$1.buttonWidth
                              })),
                      kind: {
                        TAG: /* Form */6,
                        _0: match.onSubmit
                      }
                    })));
}

var make = Organism_Newsletter;

export {
  textId ,
  Feedback ,
  make ,
}
/* CssJs Not a pure module */
